import { render } from "./HomeDashboardClientList.vue?vue&type=template&id=4a3f8161"
import script from "./HomeDashboardClientList.vue?vue&type=script&lang=js"
export * from "./HomeDashboardClientList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__